export default interface HomeMatchAdDto {
    id: string | null,
    name: string,
    linkId: number | null,
    linkType: HomeMatchAdLinkType,
    expirationDate: string | null,
    isActive: boolean,
    priority: number,
    imageUrl: string,
    linkName: string | null,
    createdAt: string | null,
    views: number,
    clicks: number,
}

export enum HomeMatchAdLinkType {
    NONE = 0,
    MATCH = 1,
    LEAGUE = 2,
}